// RadioSelector.js
// import React, { useEffect } from 'react';
import { styled } from "@mui/material/styles";
import { Radio, FormControlLabel, FormControl, FormLabel, RadioGroup } from '@mui/material';
import { AppStyle } from "../value/AppConst";

const TitleLabel = styled('div')({fontSize: '0.8rem', color:AppStyle.PrimaryRGB});
const IdLabelAppend = 'form-control-form-label-above-group';

export default function RadioSelector({
    dict,
    value,
    list,
    onChange,
    horizontal, // boolean.
    disabled
}) {

    if(!list) list = dict.selectList || [];
    const onSelect = (event) => {
        onChange(dict.id, event.target.value, false);
    }

    const labelKey = dict.labelKey || 'label';
    const valueKey = dict.valueKey || dict.id;
    const IdLabel = dict.id + IdLabelAppend;

    return (
        <FormControl>
            
                {Boolean(dict.label) ? <FormLabel id={IdLabel}><TitleLabel>{dict.label}</TitleLabel></FormLabel> : null}
            
            <RadioGroup
                aria-labelledby={IdLabel}
                name={dict.id}
                value={value || ''}
                onChange={onSelect}
                row={horizontal ? true : false}
            >
                {
                    list.map((item) => {
                        return(
                            <FormControlLabel key={item[valueKey]}
                                value={item[valueKey]}
                                control={<Radio disabled={disabled ? true : false} />}
                                label={item[labelKey]} />
                        );
                    })
                }
            </RadioGroup>
        </FormControl>
    );
}
